import { render, staticRenderFns } from "./add-edit-question.vue?vue&type=template&id=2bfac0f4&scoped=true&"
import script from "./add-edit-question.vue?vue&type=script&lang=js&"
export * from "./add-edit-question.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-question.vue?vue&type=style&index=0&id=2bfac0f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfac0f4",
  null
  
)

component.options.__file = "add-edit-question.vue"
export default component.exports